"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var BaseQuery_1 = require("./BaseQuery");

var Query_1 = require("./Query");

var CLIENT_CODE_QUERY_ID = 'clientCode';

var FundListsQuery =
/** @class */
function (_super) {
  __extends(FundListsQuery, _super);

  function FundListsQuery() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  FundListsQuery.prototype.getOptions = function () {
    var _a = this.queryOptions,
        subQueries = _a.subQueries,
        _b = _a.options,
        options = _b === void 0 ? {} : _b;
    var clientCodeQuery = (subQueries || []).find(function (subQuery) {
      return subQuery.queryId === CLIENT_CODE_QUERY_ID;
    });
    return __assign({
      clientCodeQuery: clientCodeQuery
    }, options.fundLists || {});
  };

  FundListsQuery.prototype.getRawValue = function (executionOptions) {
    var response = [];
    var context = Query_1.Query.getContext(executionOptions, this.queryOptions);
    var fundListMapping = (context || {}).fundListMapping;

    if (fundListMapping) {
      var clientCodeSubQuery = this.options.clientCodeQuery;

      if (clientCodeSubQuery) {
        var clientCodeQuery = new Query_1.Query(clientCodeSubQuery);
        var clientCode = clientCodeQuery.execute(executionOptions);

        if (clientCode) {
          for (var _i = 0, _a = Object.keys(fundListMapping); _i < _a.length; _i++) {
            var fundListName = _a[_i];
            var fundListMap = fundListMapping[fundListName];

            if (fundListMap[clientCode]) {
              response.push(fundListName);
            }
          }
        }
      }
    }

    return response;
  };

  return FundListsQuery;
}(BaseQuery_1.BaseQuery);

exports.FundListsQuery = FundListsQuery;